module.exports = __webpack_public_path__ + "img/game2.f61cbdf7.png";